import { render, staticRenderFns } from "./PollRankedResults.vue?vue&type=template&id=2b786930&scoped=true"
import script from "./PollRankedResults.vue?vue&type=script&lang=js"
export * from "./PollRankedResults.vue?vue&type=script&lang=js"
import style0 from "./PollRankedResults.vue?vue&type=style&index=0&id=2b786930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b786930",
  null
  
)

export default component.exports